import staticMapUrl from '../../assets/img/Tagungszentrum.jpg';

import React, { useEffect, useState } from 'react';
import { useAttendees } from '../common/AttendeesProvider';
import { useLocation } from 'react-router';
import DOMPurify from 'dompurify';
import linkifyStr from 'linkify-string';
import { BadgeInformation } from '../common/types';
const discordSigninUrl = 'https://discord.gg/tXkcRDysr2';
const cocUrl = '/values#coc';
const awarenessUrl = '/awareness-terms-explanations';
const trainingFeedbackUrl = 'https://forms.gle/JotvcDDLkioRNknaA';
const feedbackUrl = 'https://forms.gle/YXrBFkkHgYSRmceF7';
const hotelTipUrl = 'https://paypal.me/socratesdeutschland';
// const pingUrl = 'https://ping.socrates-conference.de';
const quickLinks = [
  [cocUrl, 'Code of Conduct'],
  [awarenessUrl, 'Awareness Terms & Explanations'],
  // [pingUrl, 'PING 👉🏾 Live Map 🧭 and Live Schedule 📅'],
  [discordSigninUrl, 'Sign in to SoCraTes Discord'],
  [trainingFeedbackUrl, 'Training day session feedback'],
  [feedbackUrl, 'Give us some general feedback ❤'],
  [hotelTipUrl, 'Tip the hotel (PayPal) 🙏'],
  [staticMapUrl, 'Static Hotel Park map (jpg)'],
];

const formatSocials = (socials: string) => {
  const linkifiedSocials = linkifyStr(socials);
  return DOMPurify.sanitize(linkifiedSocials, {
    ALLOWED_TAGS: ['a'],
    ALLOWED_ATTR: ['href', 'target'],
  });
};

export default function OnsiteQuickLinks() {
  const attendeesApi = useAttendees();
  const [badgeInformation, setBadgeInformation] = useState<
    BadgeInformation | undefined
  >(undefined);

  const location = useLocation();

  useEffect(() => {
    (async () => {
      const href = new URL(window.location.href);
      href.pathname = location.pathname;
      href.search = location.search;
      if (href.searchParams.has('attendeeId')) {
        const apiResponse = await attendeesApi.getBadgeInformation(
          href.searchParams.get('attendeeId')!,
        );
        setBadgeInformation(apiResponse);
      }
    })().catch(() => {});
  }, [location, attendeesApi]);

  return (
    <div id="onsite-quick-links" className="container">
      {badgeInformation && (
        <React.Fragment>
          <div className="row">
            <div className="col-md-12">
              <div className="page-header">
                <h1>
                  Info for{' '}
                  <span data-testid="name">
                    {badgeInformation.badgename ?? badgeInformation.nickname}
                  </span>
                </h1>
              </div>
            </div>
          </div>
          {badgeInformation.pronouns && (
            <h2>
              Pronouns:{' '}
              <span data-testid="pronouns">{badgeInformation.pronouns}</span>
            </h2>
          )}
          {badgeInformation.social && (
            <h2>
              Socials:{' '}
              <span
                data-testid="socials"
                dangerouslySetInnerHTML={{
                  __html: formatSocials(badgeInformation.social),
                }}
              ></span>
            </h2>
          )}
        </React.Fragment>
      )}
      <div className="row">
        <div className="col-md-12">
          <div className="page-header">
            <h2>Quick links to helpful onsite information</h2>
          </div>
        </div>
      </div>
      <ul>
        {quickLinks.map(([l, t], i) => {
          return (
            <li key={i}>
              <big>
                <a href={l} target="_blank" rel="noopener noreferrer">
                  {t}
                </a>
              </big>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
